// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"AddressInput_cardTitle__YbBwb"};